<lx-section-template [sectionIndex]="sectionIndex" i18n-sectionTitle sectionTitle="Further information">
  <lx-form-field label="Leisure/Interest" i18n-label [small]="true" [isValid]="formData.leisure.isValid" data-qa="enrolment-leisure-field">
    <input pInputText type="text" (focusout)="onValueChanges('leisure')" [(ngModel)]="formData.leisure.value" />
  </lx-form-field>
  <lx-form-field label="Special diet" i18n-label [small]="true" [isValid]="formData.specialDiet.isValid" data-qa="enrolment-special-diet-field">
    <input pInputText type="text" (focusout)="onValueChanges('specialDiet')" [(ngModel)]="formData.specialDiet.value" />
  </lx-form-field>
  <lx-form-field label="Allergies" i18n-label [small]="true" [isValid]="formData.allergies.isValid" data-qa="enrolment-allergies-field">
    <input pInputText type="text" (focusout)="onValueChanges('allergies')" [(ngModel)]="formData.allergies.value" />
  </lx-form-field>
  <div
    class="extras__check-box-container"
    [class.extras__check-box-container--one-column]="!isAdultSchool()"
    [class.extras__check-box-container--two-columns]="isAdultSchool()"
  >
    <lx-form-field [isValid]="formData.vegetarian.isValid" [small]="true">
      <lx-checkbox [(value)]="formData.vegetarian.value" (valueChange)="onValueChanges('vegetarian')" i18n>Vegetarian</lx-checkbox>
    </lx-form-field>
    <lx-form-field *ngIf="isAdultSchool()" [isValid]="formData.smoker.isValid" [small]="true">
      <lx-checkbox [(value)]="formData.smoker.value" (valueChange)="onValueChanges('smoker')" i18n>Smoker</lx-checkbox>
    </lx-form-field>
  </div>

  <lx-form-field
    class="qt-form-section__double-column-span"
    label="Other wishes"
    i18n-label
    [small]="true"
    [isValid]="formData.otherWishes.isValid"
    data-qa="enrolment-other-wishes-field"
  >
    <input pInputText type="text" (focusout)="onValueChanges('otherWishes')" [(ngModel)]="formData.otherWishes.value" />
  </lx-form-field>

  <lx-host-family-selection class="extras-selection__host-family-selection" (valueChanges)="updateFamilyOptions($event)"></lx-host-family-selection>

  <lx-form-field label="Insurance" i18n-label [small]="true" [isValid]="true" [required]="false" class="qt-form-section__double-column-span">
    <div class="insurance-option-container">
      <ng-container *ngFor="let option of insuranceOptions">
        <p-checkbox
          [value]="option.insuranceType"
          name="insuranceOption"
          [label]="option.name"
          [(ngModel)]="selectedInsuranceOptions"
          (ngModelChange)="saveInsuranceOptions()"
        ></p-checkbox>
      </ng-container>
    </div>
  </lx-form-field>
</lx-section-template>
